// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import Select from "react-select";
// import { useDispatch } from "react-redux";
// import { updateProfleAction } from "../../../redux/actions/user/userAction";
// import { connect } from "react-redux";
// import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";
// import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";

// export const Regions = (props) => {
//   const customStyles = {
//     control: (base, state) => ({
//       ...base,
//       top: "5px",
//       // Overwrittes the different states of border
//       borderColor: state.isFocused ? "#309CCA" : "#309CCA",
//     }),
//   };

//   const MAX_COUNTRY_SPECIFIC = 3; // ⭐ Max 3 country specific entries

//   const dispatch = useDispatch();
//   const [inputData, setInputData] = useState([]);
//   const [primaryRegion, setPrimaryRegion] = useState([]);
//   const [secondaryRegion, setSecondaryRegion] = useState([]);
//   const [countrySpecific, setCountrySpecific] = useState([]);

//   const [isEnable, setIsEnable] = useState({ save: false });
//   const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
//     useState(false);
//   const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
//     useNavigatingAway(canShowDialogLeavingPage);

//   const handleChange = (event, eventName) => {
//     setIsEnable((prevState) => ({
//       ...prevState,
//       save: true,
//     }));
//     setCanShowDialogLeavingPage(true);
//     if (
//       eventName === "primary_sector_region" ||
//       eventName === "secondary_sector_region"
//     ) {
//       if (eventName === "primary_sector_region") {
//         setPrimaryRegion(event);
//       } else {
//         setSecondaryRegion(event);
//       }
//       if (event != null) {
//         setInputData((prevState) => ({
//           ...prevState,
//           [eventName]: event["id"],
//         }));
//       } else {
//         setInputData((prevState) => ({
//           ...prevState,
//           [eventName]: null,
//         }));
//       }
//     } else {
//       setInputData((prevState) => ({
//         ...prevState,
//         [event.target.name]: event.target.value,
//       }));
//     }
//   };

//   const handleFormSubmit = (event) => {
//     event.preventDefault();
//     const updateRegion = {
//       userId: inputData.userId,
//       primary_sector_region: inputData.primary_sector_region,
//       secondary_sector_region: inputData.secondary_sector_region,
//       country_specific_region: countrySpecific,
//     };
//     dispatch(updateProfleAction(inputData.userId, updateRegion));
//     setIsEnable((prevState) => ({
//       ...prevState,
//       save: false,
//     }));
//     setCanShowDialogLeavingPage(false);
//   };

//   useEffect(() => {
//     if (Object.keys(props.profile).length > 0) {
//       const region = {
//         userId: props.profile.userId,
//         primary_sector_region: props.profile.primary_sector_region,
//         secondary_sector_region: props.profile.secondary_sector_region,
//       };
//       setInputData(region);
//       setCountrySpecific(
//         props.profile.country_specific_region &&
//           props.profile.country_specific_region.length === 0
//           ? [null]
//           : props.profile.country_specific_region
//       );
//     }

//     if (props.countries) {
//       if (inputData.primary_sector_region != null) {
//         const primaryRegionnData = props.countries.find(
//           (row) => row.id === inputData.primary_sector_region
//         );
//         if (props.primarySectorId != null) {
//           setPrimaryRegion(primaryRegionnData);
//         } else {
//           setPrimaryRegion(null);
//         }
//       }
//       if (inputData.secondary_sector_region != null) {
//         const secondaryRegionData = props.countries.find(
//           (row) => row.id === inputData.secondary_sector_region
//         );
//         if (props.secondarySectorId != null) {
//           setSecondaryRegion(secondaryRegionData);
//         } else {
//           setSecondaryRegion(null);
//         }
//       }
//     }
//   }, [props]);

//   const handleAddFormChange = () => {
//     setCountrySpecific((prevState) => [...prevState, null]);
//   };

//   const handleContryChange = (event, index) => {
//     setIsEnable((prevState) => ({ ...prevState, save: true }));
//     setCanShowDialogLeavingPage(true);
//     const values = [...countrySpecific];
//     values[index] = event["id"];
//     setCountrySpecific(values);
//   };

//   const handleRemoveFormChange = (index) => {
//     setIsEnable((prevState) => ({ ...prevState, save: true }));
//     setCanShowDialogLeavingPage(true);
//     const values = [...countrySpecific];
//     const a = values.splice(index, 1);
//     setCountrySpecific(values);
//   };

//   const [selectedOption, setSelectedOption] = useState({
//     primaryRegion: null,
//     secondaryRegion: null,
//   });

//   const [addRegion, setAddRegion] = useState([]);
//   return (
//     <div className="row margin-row">
//       {" "}
//       <DialogLeavingPage
//         showDialog={showDialogLeavingPage}
//         setShowDialog={setCanShowDialogLeavingPage}
//         confirmNavigation={confirmNavigation}
//         cancelNavigation={cancelNavigation}
//         title={"Regions"}
//       />
//       <div className="col-12 ">
//         <div className="timeline-border-box">
//           <h5>Regions</h5>
//           <div className="row">
//             <div className="col-md-6 col-12 " style={{ paddingTop: "1%" }}>
//               <label className="field-label">Primary Sector Regions</label>
//             </div>
//             <div className="col-md-5 col-10 ">
//               <Select
//                 id="primary_sector_region"
//                 name="primary_sector_region"
//                 value={
//                   props.countries &&
//                   props.countries.find(
//                     (countrie) =>
//                       countrie.id === inputData.primary_sector_region
//                   )
//                 }
//                 options={props.countries.slice(0, 19)}
//                 getOptionLabel={(option) => option.regions}
//                 getOptionValue={(option) => option.id}
//                 onChange={(event) =>
//                   handleChange(event, "primary_sector_region")
//                 }
//                 placeholder="Choose.."
//                 isClearable={true}
//                 styles={customStyles}
//                 isDisabled={props.primarySectorId === null ? true : false}
//               />
//             </div>
//             <div className="col-md-6 col-12 " style={{ paddingTop: "2%" }}>
//               <label className="field-label">Secondary Sector Regions</label>
//             </div>
//             <div className="col-md-5 col-10 " style={{ paddingTop: "1%" }}>
//               <Select
//                 id="secondary_sector_region"
//                 name="secondary_sector_region"
//                 value={
//                   props.countries &&
//                   props.countries.find(
//                     (countrie) =>
//                       countrie.id === inputData.secondary_sector_region
//                   )
//                 }
//                 options={props.countries.slice(0, 19)}
//                 getOptionLabel={(option) => option.regions}
//                 getOptionValue={(option) => option.id}
//                 onChange={(event) =>
//                   handleChange(event, "secondary_sector_region")
//                 }
//                 placeholder="Choose.."
//                 isClearable={true}
//                 styles={customStyles}
//                 isDisabled={
//                   primaryRegion === null || props.secondarySectorId === null
//                     ? true
//                     : false
//                 }
//               />
//             </div>
//           </div>
//           <div className="row">
//             {countrySpecific &&
//               countrySpecific.map((countryRegion, index) => {
//                 return (
//                   <div className="col-12 parent-col" key={index}>
//                     <div className="row cloneRowTarget  ">
//                       <div className="col-md-6 col-12">
//                         <label
//                           className="field-label"
//                           style={{ paddingTop: "5%" }}
//                         >
//                           Country Specific Experience
//                         </label>
//                       </div>
//                       <div
//                         className="col-md-5 col-10"
//                         style={{ paddingTop: "1%" }}
//                       >
//                         <Select
//                           id="countryRegion"
//                           name="countryRegion"
//                           value={
//                             props.countries &&
//                             props.countries.find(
//                               (country) => country.id === countryRegion
//                             )
//                           }
//                           options={props.countries}
//                           getOptionLabel={(option) => option.name}
//                           getOptionValue={(option) => option.id}
//                           onChange={(event) => handleContryChange(event, index)}
//                           placeholder="Choose.."
//                           isClearable={true}
//                           styles={customStyles}
//                         />
//                       </div>
//                       {index != 0 ? (
//                         <div className="col-md-1 col-12 text-right clone-row-btn-holder">
//                           <Link
//                             to=""
//                             style={{ cursor: "pointer" }}
//                             onClick={() => handleRemoveFormChange(index)}
//                             className="cloneTargetTrigger"
//                           >
//                             -
//                           </Link>
//                         </div>
//                       ) : (
//                         <></>
//                       )}
//                     </div>
//                   </div>
//                 );
//               })}
//             <div className="col-12 text-right clone-row-btn-holder">
//               <Link
//                 to=""
//                 style={{ cursor: "pointer" }}
//                 onClick={handleAddFormChange}
//                 className="cloneTargetTrigger"
//               >
//                 +
//               </Link>
//             </div>
//           </div>{" "}
//           <br />
//           <div className="col text-right ">
//             {isEnable.save ? (
//               <Link className="edit-btn" to="" onClick={handleFormSubmit}>
                
//                 <span>
//                   <img src="/assets/images/icons/save.png" alt="" />Save
//                 </span>
//               </Link>
//             ) : (
//               ""
//             )}{" "}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const mapStateToProps = (state) => {
//   const user = state.user.user;
//   const profile = state.user.profile;
//   const countries = state.admin.countries;
//   const region = state.admin.region;

//   return {
//     user: user,
//     profile: profile,
//     countries: countries,
//     region: region,
//   };
// };

// const mapDispatchToProps = {};

// export default connect(mapStateToProps, mapDispatchToProps)(Regions);


///////////////////////////////////////////////////////////////////////////

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { updateProfleAction } from "../../../redux/actions/user/userAction";
import { connect } from "react-redux";
import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";
import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";

export const Regions = (props) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      top: "5px",
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "#309CCA" : "#309CCA",
    }),
  };

  const MAX_COUNTRY_SPECIFIC = 3; // ⭐ Max 3 country specific entries
  
  const dispatch = useDispatch();
  const [inputData, setInputData] = useState([]);
  const [primaryRegion, setPrimaryRegion] = useState([]);
  const [secondaryRegion, setSecondaryRegion] = useState([]);
  const [countrySpecific, setCountrySpecific] = useState([]);

  const [isEnable, setIsEnable] = useState({ save: false });
  const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
    useState(false);
  const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
    useNavigatingAway(canShowDialogLeavingPage);

  const handleChange = (event, eventName) => {
    setIsEnable((prevState) => ({
      ...prevState,
      save: true,
    }));
    setCanShowDialogLeavingPage(true);
    if (
      eventName === "primary_sector_region" ||
      eventName === "secondary_sector_region"
    ) {
      if (eventName === "primary_sector_region") {
        setPrimaryRegion(event);
      } else {
        setSecondaryRegion(event);
      }
      if (event != null) {
        setInputData((prevState) => ({
          ...prevState,
          [eventName]: event["id"],
        }));
      } else {
        setInputData((prevState) => ({
          ...prevState,
          [eventName]: null,
        }));
      }
    } else {
      setInputData((prevState) => ({
        ...prevState,
        [event.target.name]: event.target.value,
      }));
    }
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const updateRegion = {
      userId: inputData.userId,
      primary_sector_region: inputData.primary_sector_region,
      secondary_sector_region: inputData.secondary_sector_region,
      country_specific_region: countrySpecific,
    };
    dispatch(updateProfleAction(inputData.userId, updateRegion));
    setIsEnable((prevState) => ({
      ...prevState,
      save: false,
    }));
    setCanShowDialogLeavingPage(false);
  };

  useEffect(() => {
    if (Object.keys(props.profile).length > 0) {
      const region = {
        userId: props.profile.userId,
        primary_sector_region: props.profile.primary_sector_region,
        secondary_sector_region: props.profile.secondary_sector_region,
      };
      setInputData(region);
      setCountrySpecific(
        props.profile.country_specific_region &&
          props.profile.country_specific_region.length === 0
          ? [null]
          : props.profile.country_specific_region
      );
    }

    if (props.countries) {
      if (inputData.primary_sector_region != null) {
        const primaryRegionnData = props.countries.find(
          (row) => row.id === inputData.primary_sector_region
        );
        if (props.primarySectorId != null) {
          setPrimaryRegion(primaryRegionnData);
        } else {
          setPrimaryRegion(null);
        }
      }
      if (inputData.secondary_sector_region != null) {
        const secondaryRegionData = props.countries.find(
          (row) => row.id === inputData.secondary_sector_region
        );
        if (props.secondarySectorId != null) {
          setSecondaryRegion(secondaryRegionData);
        } else {
          setSecondaryRegion(null);
        }
      }
    }
  }, [props]);

  // Limit country specific to 3
  const handleAddFormChange = () => {
    if (countrySpecific.length >= MAX_COUNTRY_SPECIFIC) {
      alert(`You can add up to ${MAX_COUNTRY_SPECIFIC} entries only.`);
      return;
    }
    setCountrySpecific((prevState) => [...prevState, null]);
  };

  const handleContryChange = (event, index) => {
    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);
    const values = [...countrySpecific];
    values[index] = event["id"];
    setCountrySpecific(values);
  };

  const handleRemoveFormChange = (index) => {
    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);
    const values = [...countrySpecific];
    const a = values.splice(index, 1);
    setCountrySpecific(values);
  };

  const [selectedOption, setSelectedOption] = useState({
    primaryRegion: null,
    secondaryRegion: null,
  });

  const [addRegion, setAddRegion] = useState([]);

   //  Remaining counter
  const remaining =
    MAX_COUNTRY_SPECIFIC -
    (countrySpecific && countrySpecific.length ? countrySpecific.length : 0);

  return (
    <div className="row margin-row">
      {" "}
      <DialogLeavingPage
        showDialog={showDialogLeavingPage}
        setShowDialog={setCanShowDialogLeavingPage}
        confirmNavigation={confirmNavigation}
        cancelNavigation={cancelNavigation}
        title={"Regions"}
      />
      <div className="col-12 ">
        <div className="timeline-border-box">
          <h5>Regions</h5>
          <div className="row">
            <div className="col-md-6 col-12 " style={{ paddingTop: "1%" }}>
              <label className="field-label">Primary Sector Regions</label>
            </div>
            <div className="col-md-5 col-10 ">
              <Select
                id="primary_sector_region"
                name="primary_sector_region"
                value={
                  props.countries &&
                  props.countries.find(
                    (countrie) =>
                      countrie.id === inputData.primary_sector_region
                  )
                }
                options={props.countries.slice(0, 19)}
                getOptionLabel={(option) => option.regions}
                getOptionValue={(option) => option.id}
                onChange={(event) =>
                  handleChange(event, "primary_sector_region")
                }
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
                isDisabled={props.primarySectorId === null ? true : false}
              />
            </div>
            <div className="col-md-6 col-12 " style={{ paddingTop: "2%" }}>
              <label className="field-label">Secondary Sector Regions</label>
            </div>
            <div className="col-md-5 col-10 " style={{ paddingTop: "1%" }}>
              <Select
                id="secondary_sector_region"
                name="secondary_sector_region"
                value={
                  props.countries &&
                  props.countries.find(
                    (countrie) =>
                      countrie.id === inputData.secondary_sector_region
                  )
                }
                options={props.countries.slice(0, 19)}
                getOptionLabel={(option) => option.regions}
                getOptionValue={(option) => option.id}
                onChange={(event) =>
                  handleChange(event, "secondary_sector_region")
                }
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
                isDisabled={
                  primaryRegion === null || props.secondarySectorId === null
                    ? true
                    : false
                }
              />
            </div>
          </div>
          <div className="row">
            {countrySpecific &&
              countrySpecific.map((countryRegion, index) => {
                return (
                  <div className="col-12 parent-col" key={index}>
                    <div className="row cloneRowTarget  ">
                      <div className="col-md-6 col-12">
                        <label
                          className="field-label"
                          style={{ paddingTop: "5%" }}
                        >
                          Country Specific Experience
                        </label>
                      </div>
                      <div
                        className="col-md-5 col-10"
                        style={{ paddingTop: "1%" }}
                      >
                        <Select
                          id="countryRegion"
                          name="countryRegion"
                          value={
                            props.countries &&
                            props.countries.find(
                              (country) => country.id === countryRegion
                            )
                          }
                          options={props.countries}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          onChange={(event) => handleContryChange(event, index)}
                          placeholder="Choose.."
                          isClearable={true}
                          styles={customStyles}
                        />
                      </div>
                      {index != 0 ? (
                        <div className="col-md-1 col-12 text-right clone-row-btn-holder">
                          <Link
                            to=""
                            style={{ cursor: "pointer" }}
                            onClick={() => handleRemoveFormChange(index)}
                            className="cloneTargetTrigger"
                          >
                            -
                          </Link>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                );
              })}
            {remaining > 0 && (
              <div className="col-12 text-right clone-row-btn-holder">
                <Link
                  to=""
                  style={{ cursor: "pointer" }}
                  onClick={handleAddFormChange}
                  className="cloneTargetTrigger"
                >
                  +
                </Link>
              </div>
            )}
          </div>{" "}
          <br />
          <div className="col text-right ">
            {isEnable.save ? (
              <Link className="edit-btn" to="" onClick={handleFormSubmit}>
                
                <span>
                  <img src="/assets/images/icons/save.png" alt="" />Save
                </span>
              </Link>
            ) : (
              ""
            )}{" "}
            <p
              style={{
                fontSize: "12px",
                textAlign: "left",
                color:  "#555" // red when max reached
              }}
            >
              {remaining > 0
                ? `${remaining} remaining`
                : "Maximum number of Regions added."}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;
  const countries = state.admin.countries;
  const region = state.admin.region;

  return {
    user: user,
    profile: profile,
    countries: countries,
    region: region,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Regions);
